import { STRIPE_PUB_KEY } from "src/config";

export function redirectToCheckout({ sessionId }: { sessionId: string }) {
  // @ts-expect-error window.Stripe
  const stripe = window.Stripe(STRIPE_PUB_KEY, { locale: "fr" });
  stripe.redirectToCheckout({ sessionId });
}
